<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row class="pb-5">
      <!-- Search Field -->
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-text-field
          v-model="search"
          @input="debounceSearch"
          prepend-icon="mdi-magnify"
          label="Search here ..."
          single-line
          solo
          hide-details
        />
      </v-col>

      <!-- Date Filter -->
      <v-col cols="12" sm="6" md="6" lg="2">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select" label="Date Range"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
      </v-col>

      <v-col cols="12" sm="4" md="4" lg="2">
        <ul>
          <li>
            <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
          content-class="deposit-withdraw-popup marketingPopup">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  tile
                  elevation="0"
                  class="text-capitalize"
                  color="#039de9"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi mdi-plus</v-icon>
                  Provide Bonus
                </v-btn>
              </template>

              <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                <v-card-title class="pb-3 text-left justify-start pl-3">
                  Provide Tradable Bonus
                </v-card-title>

                <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                  Fill in the details to provide bonus for the user
                </v-card-subtitle>

                <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-row>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Tradable Bonus A/C</legend>
                        <v-text-field
                          v-model="bonusForm.trading_account"
                          solo
                          class="custom-select"
                          label=""
                          placeholder="Enter Tradable Bonus A/C"
                          hide-details
                        ></v-text-field>
                      </fieldset>
                    </v-col>

                    <v-col cols="12">
                      <fieldset>
                        <legend>Deposit Amount</legend>
                        <v-text-field
                          v-model="bonusForm.deposit_amount"
                          solo
                          class="custom-select"
                          type="number"
                          label=""
                          placeholder="Enter Positive Deposit Amount"
                          hide-details
                        ></v-text-field>
                      </fieldset>
                    </v-col>

                    <v-col cols="12">
                      <fieldset>
                        <legend>Bonus Amount</legend>
                        <v-text-field
                          v-model="bonusForm.bonus_amount"
                          solo
                          class="custom-select"
                          type="number"
                          label=""
                          placeholder="Enter Positive Bonus Amount"
                          hide-details
                        ></v-text-field>
                      </fieldset>
                    </v-col>

                    <v-col cols="12">
                      <fieldset>
                        <legend>Remark</legend>
                        <v-text-field
                          v-model="bonusForm.remark"
                          solo
                          class="custom-select"
                          label=""
                          placeholder="Enter Remark"
                          rows="2"
                          hide-details
                        ></v-text-field>
                      </fieldset>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card-actions>
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn
                        tile
                        :loading="loading"
                        :disabled="loading"
                        @click="submitBonusForm"
                        elevation="0"
                        class="text-capitalize btn-account mr-3 px-sm-8"
                        color="greenMain"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        tile
                        color="#FF567F"
                        @click="dialogDeposit = false"
                        elevation="0"
                        class="text-capitalize btn-account px-sm-8"
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </li>
        </ul>
      </v-col>

      <!-- Summary Display -->
      <v-col cols="12" sm="6" md="4" lg="2">
        <ul>
          <li><span>Total Deposit:</span> <span>${{ formattedAllNumber(summaries?.totalDeposit) || 0 }}</span></li>
          <li><span>Total Bonus:</span> <span>${{ formattedAllNumber(summaries?.totalBonusAmount) || 0 }}</span></li>
        </ul>
      </v-col>
    </v-row>

    <!-- Data Table -->
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTableForTransaction" :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
            <v-data-table
              :headers="headers"
              :items="trades"
              :server-items-length="pagination?.total || 10"
              :options.sync="filterOptions"
              :loading="isLoading"
              :items-per-page="filterOptions.itemsPerPage"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }"
              @update:options="handleOptionsChange"
              disable-sort
            >
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary" />
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>

              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>

              <template v-slot:item.fullName="{ item }">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.client_id}`">
                  {{ `${item.fullName} (${item?.client_id})` }}
                </router-link>
              </template>

              <template v-slot:item.login="{ item }">
                {{ item?.login + " (" + (item.trading_account_type ? item.trading_account_type.substring(0, 3) : "") + ")" }}
              </template>
              <template v-slot:item.deposit_amount="{ item }">
                ${{ parseFloat(item.deposit_amount).toFixed(2) }}
              </template>
              <template v-slot:item.tradable_bonus_amount="{ item }">
                ${{ parseFloat(item.tradable_bonus_amount).toFixed(2) }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { formatNumber } from "@/_helpers/formatNumber";
import toast from "@/services/Notification";
import { ACCOUNTTYPES__ACTIONS } from "@/store/action-types";
import { TRADABLEBONUS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialogDeposit: false,
      loading: false,
      bonusForm: {
        trading_account: '',
        deposit_amount: '',
        bonus_amount: '',
        remark: '',
      },
      search: "",
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      filterOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      trading_account_type_id: null,
      headers: [
        { text: "Time", value: "time" },
        { text: "Name", value: "fullName" },
        { text: "Account No", value: "account_no" },
        { text: "Account Type", value: "trading_account_type" },
        { text: "Deposit Amount", value: "deposit_amount" },
        { text: "Bonus Rate", value: "bonus_rate" },
        { text: "Tradable Bonus", value: "tradable_bonus_amount" },
        
      ],

      modal: false,
    };
  },

  computed: {
    ...mapState("accounttypes", ["accounttypes"]),
    ...mapState("tradablebonus", ["trades", "summaries", "pagination", "isLoading"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("tradablebonus", [TRADABLEBONUS__ACTIONS.TRADABLEBONUSHISTORY,
    TRADABLEBONUS__ACTIONS.DIRECTPROVIDETRADABLEBONUS]),
    ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async fetchData() {
      const parameter = {
        page: this.filterOptions.page || 1,
        limit: this.filterOptions.itemsPerPage || 10,
        search: this.search,
        trading_account_type_id: this.trading_account_type_id || null,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      try {
        await this[TRADABLEBONUS__ACTIONS.TRADABLEBONUSHISTORY](parameter);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch data. Please try again.");
      }
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData();
      }, 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null;
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.filterOptions.page = 1;
      this.fetchData();
    },
    async submitBonusForm() {
      this.loading = true;
      try {
        const parameter = {
          trading_account: this.bonusForm.trading_account,
          deposit_amount: this.bonusForm.deposit_amount,
          bonus_amount: this.bonusForm.bonus_amount,
          remark: this.bonusForm.remark,
        };

        const response = await this[TRADABLEBONUS__ACTIONS.DIRECTPROVIDETRADABLEBONUS](parameter);

        if (response.status === false) {
          toast.error(response.message);
        } else {
          toast.success(response.message || "Bonus provided successfully!");

          this.bonusForm = {
            trading_account: '',
            deposit_amount: '',
            bonus_amount: '',
            remark: '',
          };
          this.fetchData();
          this.dialogDeposit = false;
        }
      } catch (error) {
        console.log(error);
        const errorMsg =
          error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred.";
        toast.error(errorMsg);
      } finally {
        this.loading = false;
      }
    }

    // async submitBonusForm() {
    //   this.loading = true;
    //   try {
    //     const parameter = {
    //       trading_account: this.bonusForm.trading_account,
    //       deposit_amount: this.bonusForm.deposit_amount,
    //       bonus_amount: this.bonusForm.bonus_amount,
    //       remark: this.bonusForm.remark,
    //     };

    //     const response = await this[TRADABLEBONUS__ACTIONS.DIRECTPROVIDETRADABLEBONUS](parameter);
    //     console.log(response);
    //     if (response?.status === false) {
    //       toast.error(response.data.message || "Failed to provide bonus.");
    //     } else {
    //       toast.success(response.data.message || "Bonus provided successfully!");
          
    //       // Reset the form only on success
    //       this.bonusForm = {
    //         trading_account: '',
    //         deposit_amount: '',
    //         bonus_amount: '',
    //         remark: '',
    //       };

    //       this.fetchData();
    //     }
    //   } catch (error) {
    //     console.log(error);

    //     // Try to get message from different possible locations
    //     const errorMsg =
    //       error?.response?.data?.message ||  // Axios error response message
    //       error?.message ||                   // Generic JS error message
    //       "An unexpected error occurred.";

    //     toast.error(errorMsg);
    //   }

      
    // }


  },

  created() {
    this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
    this.fetchData();
  },
};
</script>


<style scoped>
.dots::after {
  content: "";
  display: inline-block;
  animation: dotsAnimation 1.5s steps(4, end) infinite;
}

@keyframes dotsAnimation {
  0% {
    content: "";
  }

  25% {
    content: ".";
  }

  50% {
    content: "..";
  }

  75% {
    content: "...";
  }

  100% {
    content: "";
  }
}
</style>
